import Message from "./Message.jsx";
import React from 'react';

/**
 * Class to display the default template not mapped response for when a template object
 * is received, but there is not appropriate class to map it to.
 */
export default class TemplateNotMappedMessage extends Message {
    render() {
        return (
            <div className={this.generateSenderClassName('text')}>
                {this.generateSenderMessage()}
                <div className="message-text" >
                    Sorry, I currently have no way to retrieve an answer for you on that topic. For assistance, please contact a customer service representative at <a href='tel:800-480-2265'>(800) 480-2265</a>.
                </div>
            </div>
        )
    }
}